// eslint-disable-next-line banned-modules
'use strict';

import BasePageView from '@/pages/base.page-view';
import PassengersDataView from '@/blocks/pages/b-passengers-data/avia/index';
import FlightInfoView from '@/blocks/elements/b-flight-info/index';
import BaseModel from '@/classes/base.model';
import BookingModel from './model';
import BookingDuplicatesHandler from '@/blocks/utils/b-booking-duplicates-handler';
import axios from 'axios';

export default BasePageView.extend({

	events: {
		'click .b-booking__submit': 'create',
		'click .b-booking__back': 'back',
	},

	flightInfoView: null,
	passengersDataView: null,

	initialize(options) {
		const { flightToken, flightInfo, bookingSettings } = options;
		this.isInternational = flightInfo.flight && flightInfo.flight.international;
		this.isMiddleNameRequired = bookingSettings && bookingSettings.isMiddleNameRequired;
		this.keyContact = bookingSettings && bookingSettings.keyContact; // IBECORP-3417

		this.model = STATE.get(`${STATE.ROUTES.AVIA_PASSENGERS}_MODEL`);

		if (!this.model) {
			const modelJSON = STORE.get(`${STATE.ROUTES.AVIA_PASSENGERS}_MODEL`);

			if (!modelJSON) {
				this.model = new BookingModel();
			} else {
				this.model = new BookingModel(modelJSON, {
					parse: true,
				});
			}
		}
		STATE.set(`${STATE.ROUTES.AVIA_PASSENGERS}_MODEL`, this.model);

		const createBookingModel = this.model.get('createBooking');

		createBookingModel.set('flightToken', flightToken);
		this.model.set('flightInfo', new BaseModel(flightInfo));
		this.render();

		const flight = this.model.get('flightInfo').get('flight');

		this.renderFlightInfo({
			model: flight,
		});
    
		this.passengersDataView = new PassengersDataView({
			model: createBookingModel,
			seats: flight.seats,
			token: flightToken,
			flight,
			parent: this,
			bookingSettings,
			keyContact: this.keyContact,
		});
    
		if (createBookingModel.get('passengers')?.length) {
			let hasFilledCostCodes = false;
			createBookingModel.get('passengers').forEach((passengerModel) => {
				passengerModel.get('costCodes').forEach((costCode) => {
					if (costCode.get('value')) {
						hasFilledCostCodes = true;
					}
				});
				this.listenTo(passengerModel.get('costCodes'), 'change', () => {
					this.updateAviaPrice(this.model.get('createBooking').toJSON());
				});
			});
			// Если у нас уже есть заполненные costCodes, тогда запрашиваем reprice
			if (hasFilledCostCodes) {
				this.updateAviaPrice(this.model.get('createBooking').toJSON());
			}
		}

		this.ui.content.append(this.passengersDataView.$el);

		this.passengersDataView.adjustMobileTemplate(STATE.checkViewport('(max-width: 768px)'));

		this.bookingDuplicatesHandler = new BookingDuplicatesHandler({ bookingSettings });

		if (bookingSettings?.searchDuplicatesMessage) {
			this.bookingDuplicatesHandler.showSearchDuplicatesPopup(
				{
					...bookingSettings.searchDuplicatesMessage,
					onCancel: () => this.back(),
				},
			);
		}
	},

	renderFlightInfo(options) {
		if (this.flightInfoView) this.flightInfoView.remove();
		this.flightInfoView = new FlightInfoView({
			model: options.model,
		});

		this.ui.sidebar.append(this.flightInfoView.$el);
	},

	showMealPopup() {
		this._pauseBookingSubmitForPrompt();
		const mealPopup = new Widgets.Popup({
			content: 'Выбранный тип питания недоступен. Продолжить бронирование без спец. питания?',
			closeOnlyOnAction: true,
			type: 'danger',
			actions: [{
				label: 'Нет',
				action: () => {
					this._resetBookingSubmitState();
					mealPopup.hide();
				},
			}, {
				label: 'Да',
				action: () => {
					mealPopup.hide();
					logger.debug('CREATE', this.model.get('createBooking').toJSON());
					this.createBooking({
						ignoreMeal: true,
					});
				},
			}],
		});
		mealPopup.show();
	},

	create(e) {
		if (this._bookingSubmitting) {
			return;
		}
		this.disableElements(e);
		logger.debug('CREATE', this.model.get('createBooking').toJSON());
		this.createBooking();
	},

	_setSubmitButtonDisabled(disabled) {
		this.$('.b-booking__submit')
			.prop('disabled', disabled)
			.toggleClass('btn-disabled', disabled);
	},

	_beginBookingSubmit() {
		this._bookingSubmitting = true;
		this._setSubmitButtonDisabled(true);
		STATE.showLoader();
		STATE.setBookingInProcess(true);
	},

	_resetBookingSubmitState() {
		this._bookingSubmitting = false;
		this._setSubmitButtonDisabled(false);
		STATE.setBookingInProcess(false);
	},

	_pauseBookingSubmitForPrompt() {
		this._bookingSubmitting = false;
		STATE.hideLoader();
		STATE.setBookingInProcess(false);
	},

	_onBookingDuplicatePrompt(result) {
		this._pauseBookingSubmitForPrompt();
		this.bookingDuplicatesHandler.showProductDuplicatesPopup({
			...result,
			onOk: () => this.createBooking(),
			onCancel: () => this.back(),
		});
	},

	createBooking(extend = {}) {
		if (this._bookingSubmitting) {
			return;
		}
		this._beginBookingSubmit();
		let { parameters } = this.model.get('createBooking').toJSON();
		parameters = _.extend(
			{},
			parameters,
			this.bookingDuplicatesHandler.getBookingDataObj(),
			extend,
		);

		// Remove middle name for international flights
		if (this.isInternational) {
			parameters.passengers.forEach((passenger) => {
				if (this.isMiddleNameRequired) return;
				passenger.passport.middleName = '';
			});
		}

		const modelJSON = STORE.get(`${STATE.ROUTES.AVIA_PASSENGERS}`);

		if (modelJSON && modelJSON.isIntention) {
			axios.post('/midoffice/ibecorp-b2b/avia/createBooking/validate', { parameters }, this.model.get('createBooking'))
				.then(() => this.sendApproveIntentionRequest(modelJSON, parameters))
				.catch((ex) => {
					this._resetBookingSubmitState();
					throw ex;
				});
			return;
		}
	
		if (modelJSON && !modelJSON.isIntention) {
			_.each(_.keys(parameters), (key) => { 
				if (key.indexOf('externalSystem') !== -1) {
					if (parameters.externalSystemCodes !== undefined) {
						parameters.externalSystemCodes.push({uid: key.split('__')[1], code: parameters[key]});
					} else {
						parameters.externalSystemCodes = [{uid: key.split('__')[1], code: parameters[key]}];
					}
					delete parameters[key];
				}
			});
		}

		this.sendCreateBookingRequest(parameters);
	},

	sendApproveIntentionRequest(modelJSON, parameters = {}) {
		return axios.post('/midoffice/ibecorp-b2b/booking/approveIntention', {
			parameters:  {
				reservationUid: modelJSON.reservationUid,
				currentBooking: modelJSON.currentBooking,
				aviaData: {
					createParameters: {
						...parameters,
						...this.bookingDuplicatesHandler.getBookingDataObj(),
					},
				},
			},
		}, null, {enableCashing: true}).then((result) => {
			STATE.hideLoader();

			if (result.data.result.mealIsNotAvailable === true) {
				this.showMealPopup();
				return result;
			}

			if (this.bookingDuplicatesHandler.shouldShowProductDuplicatesPopup(result.data.result?.aviaBookingResult)) {
				this._onBookingDuplicatePrompt(result.data.result.aviaBookingResult);
				return result;
			}

			STORE.set(STATE.ROUTES.CABINET_ORDER, {
				orderUid: result.data.result.aviaBookingResult.newBooking.uid,
			}, 48 * 60);
			if (STATE.getQueryVariable('pnr') != null) {
				window.location.href = `${STATE.getRootUrl()}#${STATE.ROUTES.CABINET_ORDER}/${result.data.result.aviaBookingResult.newBooking.uid}`;
			} else {
				STATE.navigate([STATE.ROUTES.CABINET_ORDER, result.data.result.aviaBookingResult.newBooking.uid].join('/'));
			}

			return result;
		}).catch((ex) => {
			this._resetBookingSubmitState();
			throw ex;
		});
	},

	sendCreateBookingRequest(parameters) {
		return axios.post('/midoffice/ibecorp-b2b/avia/createBooking', {parameters}, this.model.get('createBooking'), {enableCashing: true})
			.then((result) => {
				STATE.hideLoader();

				// no check for async actions - just show messages and do not interrupt the logic below
				if (result?.data?.result?.messages && !_.isEmpty(result.data.result.messages)) {
					const messages = result.data.result.messages;
					const popup = new Widgets.Popup({
						type: 'info',
						content: messages.length && _.map(messages, (m) => m.text).join('<br/>'),
						actions: [
							{
								label: L10N.get('common.close'),
								action: () => popup.hide(),
							},
						],
					});
					popup.show();
				}

				if (result.data.result.mealIsNotAvailable === true) {
					this.showMealPopup();
					return result;
				}

				if (this.bookingDuplicatesHandler.shouldShowProductDuplicatesPopup(result.data.result)) {
					this._onBookingDuplicatePrompt(result.data.result);
					return result;
				}

				STORE.set(STATE.ROUTES.CABINET_ORDER, {
					orderUid: result.data.result.newBooking.uid,
				}, 48 * 60);
				if (STATE.getQueryVariable('pnr') != null) {
					window.location.href = `${STATE.getRootUrl()}#${STATE.ROUTES.CABINET_ORDER}/${result.data.result.newBooking.uid}`;
				} else {
					STATE.navigate([STATE.ROUTES.CABINET_ORDER, result.data.result.newBooking.uid].join('/'));
				}

				return result;
			}).catch((ex) => {
				this._resetBookingSubmitState();
				throw ex;
			});
	},

	updateAviaPrice(parameters) {
		/* Пока только для обновления данных по travelPolicyCompliance */
		return axios.post('/midoffice/ibecorp-b2b/avia/price', parameters).then((res) => {
			if (res?.data?.result?.flight) {
				this.model.get('flightInfo').set('flight', res.data.result.flight);
				this.renderFlightInfo({
					model: this.model.get('flightInfo').get('flight'),
				});
			}
		});
	},

	back(e) {
		if (e != null) {
			e.preventDefault();
		}

		STATE.navigate(STATE.ROUTES.AVIA_TICKETS);
	},

	remove() {
		this.bookingDuplicatesHandler.remove();
		BasePageView.prototype.remove.call(this);
	},

}, {
	async load() {
		if (!STATE.getCountries()) {
			await STATE.loadCountries();
		}
		return new Promise((resolve, reject) => {
			const {flightToken} = STORE.get(STATE.ROUTES.AVIA_PASSENGERS) || {};
			const promises = [];

			if (!flightToken) {
				STATE.navigate(STATE.ROUTES.INDEX);
				return;
			}

			promises.push(axios.post('/midoffice/ibecorp-b2b/avia/getFlightInfo', {
				parameters: {
					flightToken,
				},
			}));

			/*
				По идее, при первом запросе у нас будет только токен без пассажиров, и список organizationCostCodes
				должен прийти на всю организацию. Но он может не содержать в себе зависимые UDIDы.
			*/

			promises.push(axios.post('/midoffice/ibecorp-b2b/avia/getBookingFormSettings', {
				parameters: {
					token: flightToken,
				},
			}));

			Promise.all(promises).then((result) => {
				const params = {
					flightToken,
					flightInfo: result[0].data.result,
				};

				if (result[1] != null) {
					params.bookingSettings = result[1].data.result;
				}
				resolve(params);
			}).catch(reject);
		});
	},
});
